import logoutIcon from "../../assets/logoutIcon.svg";
import success from "../../assets/success.svg";
import mask from "../../assets/mask.svg";
import deleteCard from "../../assets/delete-card.svg";
import confirmIcon from "../../assets/confirm-icon.svg";
import successIcon1 from "../../assets/success-1.svg";

export const modalVariant = {
  LOGOUT: "logout_modal",
  PAYMENT_SUCCESSFULL: "payment_modal",
  
  PROFILE_CREATED: "profile_modal",
  // CHANGE_PASSWORD: "change_password_modal",
  RESTAURANT_ADDED: "restaurant_added",
  CANCEL_SUBSCRIPTION: "Cancel_Subscription",
  DELETE_CARD: "delete_card",
  DELETE_ACCOUNT: "delete_account",
  TRIAL_SUCCESSFULL: "trail_modal",
  POSTDEAL_SUCCESSFULL: "postdeal_modal",
  CHANGE_PASSWORD_SUCCESSFULL: "changePassword_modal",
  DELETE_AD: "delete_ad",
  PROFILE_UPDATE_SUCCESSFULL: "profile_update",
  MAKE_PRIMARY_CARD: "primary_card",
  SUBSCRIPTION_CREATED: "subscription_created",
  CREATE_USER: "create_user",
};

export const getModalProps = ({
  modalType,
  resolveCallback,
  rejectCallback,
  status,
}) => {
  const modalProps = {
    resolveCallback,
    rejectCallback,
  };
  switch (modalType) {
    case modalVariant.CREATE_USER:
      return {
        ...modalProps,
        subText: "Email sent Successfully",
        successButton: true,
        image: confirmIcon,
        resolveButton: {
          label: "Create User",
          variant: "contained",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };
     
    case modalVariant.PROFILE_CREATED:
      return {
        ...modalProps,
        subTitle: "Congratulations!",
        subText: "Your Profile has been Created Successfully",
        successButton: true,
        image: confirmIcon,
        resolveButton: {
          label: "Done",
          variant: "contained",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.RESTAURANT_ADDED:
      return {
        ...modalProps,
        subTitle: "Hurray!",
        subText: "Restaurant Details has been Added Successfully!",
        successButton: true,
        image: successIcon1,
        resolveButton: {
          label: "Done",
          variant: "contained",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.PROFILE_PEDNING:
      return {
        ...modalProps,
        subTitle:
          status === "Pending"
            ? "Your Account Is Still Under Reviewing"
            : "Your Account Got Suspended",
        image: mask,
        resolveButton: {
          label: "Reload",
          variant: "contained",
          color: "secondary",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.PAYMENT_SUCCESSFULL:
      return {
        ...modalProps,
        subTitle: "Congratulations! Payment Successfull",
        image: mask,
        resolveButton: {
          label: "Done",
          variant: "contained",
          color: "secondary",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.TRIAL_SUCCESSFULL:
      return {
        ...modalProps,
        subTitle:
          "Congratulations! You have successfully opted for a free trial of 7 days.",
        resolveButton: {
          label: "Done",
          variant: "contained",
          color: "secondary",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.LOGOUT:
      return {
        ...modalProps,
        subText: "Are you sure you want to logout from this Account?",
        image: logoutIcon,
        resolveButton: {
          label: "Yes",
          variant: "outlined",
          color: "info",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
        rejectButton: {
          label: "No",
          variant: "contained",
          color: "info",
          onClick: rejectCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.DELETE_ACCOUNT:
      return {
        ...modalProps,
        image: deleteCard,
        subText: "Are you sure you want to delete this Account?",
        resolveButton: {
          label: "Yes",
          variant: "contained",
          color: "info",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
        rejectButton: {
          label: "No",
          variant: "outlined",
          color: "info",
          onClick: rejectCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.CANCEL_SUBSCRIPTION:
      return {
        ...modalProps,
        image: deleteCard,
        subTitle: "Are you sure you want to cancel this subscription?",
        subText:
          "Lorem ipsum dolor sit amet consectetur. Sodales zxsit tristique massa.",
        resolveButton: {
          label: "Yes",
          variant: "contained",
          color: "info",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
        rejectButton: {
          label: "No",
          variant: "outlined",
          color: "info",
          onClick: rejectCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.MAKE_PRIMARY_CARD:
      return {
        ...modalProps,
        image: confirmIcon,
        subText: "Are you sure you want to make this Card as Primary card?",
        resolveButton: {
          label: "Yes",
          variant: "contained",
          color: "info",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
        rejectButton: {
          label: "No",
          variant: "outlined",
          color: "info",
          onClick: rejectCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.DELETE_CARD:
      return {
        ...modalProps,
        image: deleteCard,
        subText: "Are you sure you want to delete this Card?",
        resolveButton: {
          label: "Yes",
          variant: "contained",
          color: "info",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
        rejectButton: {
          label: "No",
          variant: "outlined",
          color: "info",
          onClick: rejectCallback,
          size: "small",
          fullWidth: true,
        },
      };

    case modalVariant.POSTDEAL_SUCCESSFULL:
      return {
        ...modalProps,
        subTitle: "Deal Posted Successfully!",
        image: success,
        resolveButton: {
          label: "Done",
          variant: "contained",
          color: "secondary",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
        handleClose: (event, reason) => {
          if (reason && reason == "backdropClick") return;
        },
      };
    case modalVariant.CHANGE_PASSWORD_SUCCESSFULL:
      return {
        ...modalProps,
        subTitle: "Your Password has been changed Successfully!",
        image: success,
        resolveButton: {
          label: "Done",
          variant: "contained",
          color: "secondary",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };
    case modalVariant.PROFILE_UPDATE_SUCCESSFULL:
      return {
        ...modalProps,
        subTitle: "Your profile has been updated Successfully!",
        image: success,
        resolveButton: {
          label: "Done",
          variant: "contained",
          color: "secondary",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };
    case modalVariant.DELETE_AD:
      return {
        ...modalProps,
        subText: "Are you sure you want to permanently delete this Ad?",
        image: deleteCard,
        resolveButton: {
          label: "Yes",
          variant: "contained",
          color: "info",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
        rejectButton: {
          label: "No",
          variant: "outlined",
          color: "info",
          onClick: rejectCallback,
          size: "small",
          fullWidth: true,
        },
      };
    case modalVariant.SUBSCRIPTION_CREATED:
      return {
        ...modalProps,
        subTitle: "Thank-you!",
        subText: "Payment has been Successfully Completed",
        image: confirmIcon,
        successButton: true,
        resolveButton: {
          label: "Done",
          variant: "contained",
          color: "secondary",
          onClick: resolveCallback,
          size: "small",
          fullWidth: true,
        },
      };
    default:
      return {};
  }
};
